import React from 'react';


export default class MoleculeDetailsPage extends React.Component {

  render() {
    return (
      <div>Molecule Detail Page: {this.props.match.params.fp}</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/MoleculeDetailsPage.jsx